import { initializeStore as R } from "@seamless/store";
import { initializeLogger as z } from "@seamless/logger";
import { getTranslation as V } from "@owc/aem-translations-util";
/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
/*! B2X@SHARED 2.131.0 */
const S = {
  AEM_CONNECTION_NAME: "OWC_AEM_ENV",
  REGISTRY_CONNECTION_NAME: "OWC_COMPONENT_REGISTRY",
  TRACKING_CONNECTION_NAME: "OWC_TRACKING_MANAGER",
  AUTH_CONNECTION_NAME: "B2XCORE_AUTHENTICATION",
  PROFILE_CONNECTION_NAME: "B2XCORE_PROFILE"
}, j = "https://i18n.oneweb.mercedes-benz.com/projects";
async function x(e, t = 6e4) {
  const o = R();
  return await _(e, t) ? o.getConnectionDispatchers(e) : Promise.resolve({});
}
async function _(e, t = 1) {
  return R().getConnectionDispatchers(e, t).then(() => !0).catch(() => !1);
}
async function de(e) {
  const t = R();
  return await _(
    S.REGISTRY_CONNECTION_NAME
  ) ? new Promise((n) => {
    t.once(S.REGISTRY_CONNECTION_NAME, (r) => {
      const s = Object.values(r.components);
      n(e ? e(s) : s);
    });
  }) : Promise.resolve([]);
}
function G() {
  return K(S.AEM_CONNECTION_NAME);
}
async function K(e) {
  const t = R();
  return await _(e, 5) ? new Promise((n) => {
    t.once(e, (r) => {
      n(r);
    });
  }) : Promise.resolve({});
}
const Y = "2.131.0", W = "28.5.2025, 13:54:29";
function Se(e) {
  try {
    JSON.parse(e);
  } catch {
    return !1;
  }
  return !0;
}
function X() {
  return typeof window < "u";
}
function Re() {
  return X() && location.hostname.includes("localhost");
}
function H(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Ie(e) {
  if (typeof e == "object" && e !== null) {
    if (typeof Object.getPrototypeOf == "function") {
      const t = Object.getPrototypeOf(e);
      return t === Object.prototype || t === null;
    }
    return H(e);
  }
  return !1;
}
async function J(e) {
  try {
    return { data: await e, error: null };
  } catch (t) {
    return { data: null, error: t };
  }
}
function Z(e, t = /* @__PURE__ */ new WeakSet()) {
  if (t.has(e))
    return e;
  t.add(e), Object.freeze(e);
  for (const o of Object.keys(e)) {
    const n = e[o];
    q(n) && !Object.isFrozen(n) && Z(n, t);
  }
  return e;
}
function q(e) {
  return typeof e == "object" && e !== null;
}
function Q(e, t) {
  if (typeof e != "object" || e === null)
    return t;
  if (typeof t != "object" || t === null)
    return e;
  const o = Array.isArray(e) ? [...e] : { ...e };
  for (const n in t) {
    const r = t[n], s = e[n];
    Array.isArray(s) && Array.isArray(r) ? o[n] = [...s, ...r] : typeof r == "object" && r !== null && !Array.isArray(r) && typeof s == "object" && s !== null && !Array.isArray(s) ? o[n] = Q(s, r) : o[n] = r;
  }
  return o;
}
const y = {
  BOOTSTRAP: "Bootstrap",
  TRACKING: "Tracking",
  TRANSLATION: "Translation"
}, i = {
  LOG: 1,
  WARN: 2,
  ERROR: 3,
  INFO: 4,
  DEFAULT: 5
};
function ee(e, t) {
  const { B2X_VERSIONS: o = {} } = window || {};
  if (!o[e]) {
    const { buildTime: s, version: a } = t;
    Object.assign(window, {
      B2X_VERSIONS: {
        [e]: `${e}@${a}-${s}`,
        ...o
      }
    });
  }
  const n = z(e);
  return (s, a) => {
    const { args: u = [], level: p = i.LOG, group: E = "Default" } = a || {}, m = new Intl.DateTimeFormat(["pt-PT", "de-DE", "en-GB"], {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(Date.now()), [O, d] = m.split(", "), c = `${O} | ${d} | ${E || ""}
${s}`, B = {
      [i.LOG]: "log",
      [i.WARN]: "warn",
      [i.ERROR]: "error",
      [i.INFO]: "log",
      [i.DEFAULT]: "log"
    }[p] ?? "log", v = n[B] ?? n.log;
    u != null && u.length ? v.call(n, c, ...u) : v.call(n, c);
  };
}
const te = "B2X@SHARED", T = ee(te, { buildTime: W, version: Y }), ne = "locales", $ = "translations", oe = "localesTimestamp", re = 24 * 60 * 60 * 1e3;
let L, P;
const se = async (e, t) => {
  L = `${$}.${e}.${ne}`, P = `${$}.${e}.${oe}`;
  const o = localStorage.getItem(L), n = localStorage.getItem(P);
  if (o && n) {
    const r = new Date(n);
    if ((/* @__PURE__ */ new Date()).getTime() - r.getTime() < re)
      return JSON.parse(o);
  }
  return await ae(e, t);
};
async function ae(e, t) {
  const o = `${j}/${e}/locales?per_page=100`, { data: n, error: r } = await J(
    (async () => (await fetch(o, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    })).json())()
  );
  if (r || !(n != null && n.length))
    return T(`${t}: Error fetching i18n locales`, {
      args: [r ?? "Locales require to be fetched after a timeout"],
      group: y.TRANSLATION,
      level: r ? i.ERROR : i.INFO
    }), [];
  const s = n.map((a) => a.name);
  return localStorage.setItem(L, JSON.stringify(s)), localStorage.setItem(P, (/* @__PURE__ */ new Date()).toISOString()), s;
}
const b = async (e, t, o) => (await se(t, o)).includes(e);
let A;
const k = "DE", F = "en", f = `${F}-${k}`;
let l = f;
const N = /* @__PURE__ */ new Map();
async function Ce(e, t) {
  A = t;
  const { country: o = k, language: n = F } = await G();
  l = `${n}-${o}`;
  let r = await b(l, e, A);
  if (!r) {
    if (l = f, r = await b(l, e, A), !r)
      return T(
        `${A}: Neither ${l} nor the default locale ${f} translations were found. No translations will be loaded.`,
        {
          args: [],
          level: i.INFO,
          group: y.TRANSLATION
        }
      ), N;
    T(
      `${A}: Translations for ${l} were not found, falling back to default locale ${f}.`,
      {
        args: [],
        level: i.INFO,
        group: y.TRANSLATION
      }
    );
  }
  return await h(f, e), l === f || await h(l, e), N;
}
const h = async (e, t) => {
  try {
    N.set(e, {
      locale: e,
      messages: {
        [e]: await V(e, t, "i18next")
      }
    });
  } catch (o) {
    T(`${A}: Error fetching translations for ${e}.`, {
      args: [o],
      level: i.INFO,
      group: y.TRANSLATION
    });
  }
};
function we() {
  const { locale: e, messages: t } = N.get(l) ?? { locale: "unknown", messages: {} }, { locale: o, messages: n } = N.get(f) ?? {
    locale: "unknown",
    messages: {}
  }, r = t[e] || {}, s = n[o] || {};
  return {
    exist: (a) => M(r, s, a) !== a,
    t: (a) => M(r, s, a),
    availableLocales: [e],
    locale: e
  };
}
function M(e, t, o) {
  return o.split(".").reduce((n, r) => n == null ? void 0 : n[r], e) || o.split(".").reduce((n, r) => n == null ? void 0 : n[r], t) || o;
}
const Le = {
  PRIVATE: "profile.context.private.registered",
  COMPANY: "profile.context.company.registered",
  GUEST_PRIVATE: "profile.context.private.guest",
  GUEST_COMPANY: "profile.context.company.guest",
  ADD_COMPANY: "profile.context.company.add",
  NOT_AVAILABLE: "profile.context.not.available",
  NOTIFICATIONS_PROFILES_NOT_AVAILABLE: "profile.context.notifications.profilesNotAvailable",
  PROFILE_NOT_AVAILABLE: "profile.context.not.available"
};
async function Pe(e) {
  var d;
  const { packageName: t, event: o, category: n, label: r, action: s, name: a, URL: u = void 0, state: p } = e, E = `${e.type}-${e.version}`, O = {
    event: o,
    eventDetail: {
      category: n,
      action: s,
      label: r,
      URL: u,
      name: a,
      state: p
    },
    application: {
      id: "B2X",
      version: E,
      parentApplicationId: "aem"
    }
  };
  try {
    const c = await x(S.TRACKING_CONNECTION_NAME);
    await ((d = c == null ? void 0 : c.pushTrackingEvent) == null ? void 0 : d.call(c, O));
  } catch (c) {
    T(`${t} Analytics track failure`, {
      args: [c],
      level: i.WARN,
      group: y.TRACKING
    });
  }
}
function _e(e) {
  return new URLSearchParams(window.location.search).get(e);
}
function ie(e) {
  if (typeof e == "string")
    try {
      return JSON.parse(e);
    } catch {
      return;
    }
}
function U(e) {
  return {
    get size() {
      return e.length;
    },
    keys() {
      return Array.from({ length: this.size }, (t, o) => e.key(o)).filter(Boolean);
    },
    get(t, o) {
      const n = e.getItem(t);
      if (n === null)
        return o;
      const r = ie(n);
      return r !== void 0 ? r : typeof o == "string" || o === void 0 && typeof n == "string" ? n : o;
    },
    getAll() {
      return Object.fromEntries(this.keys().map((t) => [t, this.get(t)]));
    },
    set(t, o) {
      e.setItem(t, JSON.stringify(o));
    },
    remove(t) {
      e.removeItem(t);
    },
    clear() {
      e.clear();
    },
    key(t) {
      return e.key(t);
    },
    has(t) {
      return e.getItem(t) !== null;
    }
  };
}
function D(e) {
  return typeof window > "u" ? le() : window[e];
}
function ce() {
  return {
    local: U(D("localStorage")),
    session: U(D("sessionStorage"))
  };
}
function le() {
  const e = /* @__PURE__ */ new Map();
  return {
    get length() {
      return e.size;
    },
    getItem: (t) => e.get(t) ?? null,
    setItem: (t, o) => e.set(t, o),
    removeItem: (t) => e.delete(t),
    clear: () => e.clear(),
    key: (t) => Array.from(e.keys())[t] ?? null
  };
}
const ve = ce(), ue = /* @__PURE__ */ new Set([
  "DE",
  "SE",
  "AT",
  "BE",
  "CH",
  "CZ",
  "DK",
  "SK",
  "ES",
  "FR",
  "HU",
  "IT",
  "LU",
  "NL",
  "PL",
  "PT",
  "RO"
]), ge = /* @__PURE__ */ new Set([
  "SG",
  "AU",
  "ID",
  "IN",
  "JP",
  "KR",
  "MY",
  "NZ",
  "TH",
  "TR",
  "VN",
  "EG",
  "ZA",
  "BR"
]), fe = /* @__PURE__ */ new Set(["US", "CA", "MX"]), I = {
  EU: "EU",
  AP: "AP",
  NA: "NA"
};
function Oe(e, t) {
  for (const [o, n] of t.entries())
    if (n.has(e))
      return o;
}
const g = {
  LOCAL: "local",
  DEVELOP: "dev",
  TEST: "test",
  INT: "int",
  PPROD: "pprod",
  PROD: "prod"
}, C = {
  DEV: "https://dev.api.oneweb.mercedes-benz.com",
  INT: "https://int.api.oneweb.mercedes-benz.com",
  PROD: "https://api.oneweb.mercedes-benz.com"
};
function Ae(e) {
  return Object.values(g).includes(e);
}
function Ne(e) {
  const t = e.toLowerCase();
  if (!Ae(t))
    throw new Error(`Invalid stage: "${e}". Expected one of: ${Object.values(g).join(", ")}`);
  return t;
}
async function $e(e, t = []) {
  const o = await G(), { country: n, stage: r, apiUrl: s } = o, a = Ne(r), { stageUrls: u, regionCountryMap: p } = pe(e), E = u[a];
  if (t.includes(a))
    return w(E, n, a);
  const m = Oe(n, p);
  if (m) {
    const O = o[`apiUrl${m}`];
    if (O)
      return w(`${O}/${e}`, n, a);
  }
  if (s)
    return w(`${s}/${e}`, n, a);
  throw new Error(`Unable to resolve service URL for country "${n}" and stage "${r}"`);
}
function w(e, t, o) {
  return { serviceUrl: e, country: t, stage: o };
}
function pe(e) {
  const t = `${C.DEV}/${e}`, o = `${C.INT}/${e}`, n = `${C.PROD}/${e}`, r = {
    [g.LOCAL]: t,
    [g.DEVELOP]: t,
    [g.TEST]: o,
    [g.INT]: o,
    [g.PPROD]: o,
    [g.PROD]: n
  }, s = /* @__PURE__ */ new Map([
    [I.EU, ue],
    [I.AP, ge],
    [I.NA, fe]
  ]);
  return {
    stageUrls: r,
    regionCountryMap: s
  };
}
export {
  C as BASE_API_URLS,
  S as CONNECTIONS,
  y as LOG_GROUPS,
  i as LOG_LEVEL,
  j as PHRASE_BASE_URL,
  Le as PROFILE_CONTEXT_KEYS,
  g as STAGE,
  W as buildTime,
  le as createMemoryStorage,
  Z as deepFreeze,
  Q as deepMerge,
  Pe as dispatchAnalytics,
  G as getAemConfig,
  de as getComponentRegistryConfig,
  x as getConnectionDispatchers,
  K as getConnectionState,
  _e as getQueryParameter,
  $e as getServiceRegionConfig,
  ee as initializeLogger,
  Re as isLocalhost,
  H as isObject,
  Ie as isPlainObject,
  _ as isSeamlessConnectionAvailable,
  Ae as isStage,
  Se as isStringified,
  X as isWindow,
  Ce as loadTranslations,
  Ne as normalizeStage,
  ve as storage,
  J as tryCatch,
  we as useTranslations,
  Y as version
};
//# sourceMappingURL=index.mjs.map
